<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M37.5 31.5H34V34h-2.5v3.5H34V40h3.5v-2.5H40V34h-2.5v-2.5z"/><path d="M40.7 29.17h.3V15a2 2 0 00-1-1.71L25 4.37a2 2 0 00-2.06 0L8 13.31A2 2 0 007 15v18a2 2 0 001 1.71l15 9a2 2 0 001 .29 2 2 0 001-.29L29.41 41A8.24 8.24 0 1040.7 29.17zM24 7.25l12.56 7.5-4.7 2.81-12.56-7.5zm0 15l-12.56-7.5 4.93-2.95 12.56 7.51zm-14-4.86l12.5 7.46v15L10 32.4zm15.5 22.47v-15L38 17.39v10.43a7.86 7.86 0 00-2.23-.32 8.24 8.24 0 00-7.81 10.9zM35.75 42A6.25 6.25 0 1142 35.75 6.25 6.25 0 0135.75 42z"/></svg>